import React from 'react'
import img from '../../../assets/footerlogo.png'
import styled, { css } from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import instagramIcon from './../../../assets/instagram.png'
import facebookIcon from './../../../assets/facebook.png'
import telegramIcon from './../../../assets/telegram.png'
import pinterestIcon from './../../../assets/pinterest.png'

import { useContactModal } from '../../../context/ContactModalContext'

const Section = styled.footer`
  width: 100%;
  color: #000;
  background-color: rgba(234, 226, 218, 0.6);
  flex-shrink: 0;
  position: relative;
  margin-top: 40px;
`

const Container = styled.div`
  max-width: 1200px;
  width: 90%;
  margin: 0 auto;
  padding: 40px 0 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  align-items: start;

  @media (max-width: 577px) {
    display: block;
    max-width: 80%;
    padding: 35px 20px 0;
  }
`

const LogoCont = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 100%;
    max-width: 280px;
    height: auto;
    filter: saturate(90%);
  }

  @media (max-width: 577px) {
    justify-content: left;
    align-self: center;
    position: relative;
    margin: 0;

    img {
      width: 260px;
      height: 110px;
    }
  }
`

const FooterText = styled.div`
  display: contents;

  @media (max-width: 577px) {
    display: flex;
    padding: 0;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
`

const FooterItem = styled.div`
  color: #010101;

  @media (max-width: 577px) {
    padding: 0;
    margin-right: 130px;

    &:first-child {
      margin-left: 0;
      margin-bottom: 20px;
    }

    &:last-child {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }
`

const FooterItemTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 42px;
  opacity: 0.8;
  font-family: 'Palatino Linotype', serif;
  white-space: nowrap;
`

const sharedLinkStyles = css`
  display: block;
  text-decoration: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 42px;
  color: inherit;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`

const FooterItemLink = styled(Link)`
  ${sharedLinkStyles}
`

const FooterItemBtm = styled.button`
  ${sharedLinkStyles}
  background: none;
  border: none;
  padding: 0;
  font-family: 'Montserrat', sans-serif;
  text-align: left;
`

const SocailWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 20px;
  padding: 40px 0 60px;

  img {
    width: 30px;
    height: 30px;
  }

  @media (max-width: 577px) {
    padding: 40px 0 70px;
    gap: 0;

    a {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }

    img {
      width: 25px;
      height: 25px;
    }
  }
`

const Footer = () => {
  const { t } = useTranslation()
  const { openContactModal } = useContactModal()

  return (
    <Section>
      <Container>
        <LogoCont>
          <img src={img} alt="logo" />
        </LogoCont>

        <FooterText>
          <FooterItem>
            <FooterItemTitle>{t('aboutUs')}</FooterItemTitle>
            <FooterItemLink to="/ourHistory">{t('ourHistory')}</FooterItemLink>
            <FooterItemBtm onClick={openContactModal}>{t('contacts')}</FooterItemBtm>
            <FooterItemLink to="/ourPartners">{t('OurPartners')}</FooterItemLink>
          </FooterItem>

          <FooterItem>
            <FooterItemTitle>{t('legalInfo')}</FooterItemTitle>
            <FooterItemLink to="/termsOfUse">{t('termsOfUse')}</FooterItemLink>
            <FooterItemLink to="/privacyPolicy">{t('privacyPolicy')}</FooterItemLink>
            <FooterItemLink to="/recomendation">{t('usagRecommendation')}</FooterItemLink>
          </FooterItem>
        </FooterText>
      </Container>

      <SocailWrapper>
        <Link to="//instagram.com/toobears_com?r=nametag" target="_blank">
          <img src={instagramIcon} alt="instagram" />
        </Link>
        <Link to="//www.facebook.com/toobearscom" target="_blank">
          <img src={facebookIcon} alt="facebook" />
        </Link>
        <Link to="//t.me/toobearscom" target="_blank">
          <img src={telegramIcon} alt="telegram" />
        </Link>
        <Link to="//www.pinterest.com/" target="_blank">
          <img src={pinterestIcon} alt="pinterest" />
        </Link>
      </SocailWrapper>
    </Section>
  )
}

export default Footer